import React from "react";
import {
  getLocale,
  isMoreThanHours,
  formatDateRange,
} from "../../helpers/dates";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import styles from "./EventHeader.module.css";

const EventHeader = ({
  eventImg,
  eventName,
  eventDescription,
  eventDate,
  eventEndDate,
  paxs = null,
  content,
  size = "normal",
}) => {
  const language = useSelector((state) => state.app.language);
  const locale = getLocale(language);
  const formattedEventDate = new Date(eventDate);
  const formattedEventEndDate = eventEndDate ? new Date(eventEndDate) : null;
  const isMultiDayEvent =
    eventDate &&
    eventEndDate &&
    isMoreThanHours(formattedEventDate, formattedEventEndDate);

  const getFormattedDate = () => {
    if (isMultiDayEvent) {
      return formatDateRange(eventDate, eventEndDate, locale);
    }

    return locale.code === "es"
      ? format(formattedEventDate, "EEEE, d 'de' MMMM", { locale })
      : format(formattedEventDate, "EEEE, d MMMM", { locale });
  };

  return (
    <div className="row">
      <div
        className={`col-auto pe-0 ${styles.headerImg} ${
          size !== "normal" ? styles.headerImgSmall : ""
        }`}
      >
        <img src={eventImg} alt="show" />
      </div>
      <div
        className={`col d-flex flex-column ${
          size !== "normal" ? "my-auto" : "justify-content-between"
        }`}
      >
        <div>
          <div className="fw-bold font-normal">{eventName}</div>
          <div className="text-secondary font-small">{eventDescription}</div>
        </div>
        {eventDate && (
          <div className="fw-600 text-tertiary mt-2">
            <div className="sentences-capitalize">{getFormattedDate()}</div>
            <div>{content} </div>
            {!isMultiDayEvent && (
              <div>{paxs || format(formattedEventDate, "h:mm aaa")} </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default EventHeader;
